/*
 * @Author: zhaoyu zhaoy@normstar.com
 * @Date: 2024-03-25 17:40:09
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-08-08 10:06:09
 * @FilePath: \ns-web-evaluation\pc\src\utils\ehome.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import dayjs from 'dayjs'
import { getAppEnvConfig } from '@/utils/env'
import { useUserStoreWithOut } from '@/store/user'
import native from './native'
const { isEhome, isEhomePro } = getAppEnvConfig()

export const inEHomeApp = function () {
  const sUserAgent = window.navigator.userAgent.toLowerCase()
  const reg = /ehomeapp_[A-Za-z]+_\d+(\.\d+)(\.\d+)/g
  // 判断是否在ehome内
  return !!sUserAgent.match(reg)
}

// 获取e家登陆token和用户account,加密
export function getEncryptedMessage() {
  return native({ methodName: 'getAccountMessage', data: { isEncrypted: '1' } })
}

// 获取e家登陆token和用户account,不加密
export function getAccountMessage() {
  return native({ methodName: 'getAccountMessage', data: [] })
}

// 获取当前登录的用户信息
export function getCollectUserInfo() {
  return native({ methodName: 'getCollectUserInfo', data: {} })
}

export function downloadFile({ url, md5, name, size, header, unZipFlag, deleteFlag, breadkPoint }) {
  return native({
    methodName: 'download',
    data: {
      url,
      md5,
      name,
      size,
      header,
      unZipFlag,
      deleteFlag,
      breadkPoint
    }
  })
}

// 获取文件保存地址
export function getFilePath(md5) {
  return native({ methodName: 'getFilePath', data: { name: md5 } })
}

// 获取用户头像
export function getAlbumByEmpID(empID) {
  return native({
    className: 'Information',
    methodName: 'getAlbumByEmpID',
    data: [{ empID }]
  })
}

// 获取某个员工信息base64
export function getContactBase64Img(empID) {
  return native({ className: 'GetContacts', methodName: 'getContactBase64Img', data: [empID] })
}

// 获取指定的员工详细信息。
export function getContact(empID) {
  return native({ className: 'GetContacts', methodName: 'getContact', data: [empID] })
}

// 获取多个员工信息 传入数组:["228294","225683"]，请注意！
export function getContacts(empIDs) {
  return native({ className: 'GetContacts', methodName: 'getContacts', data: empIDs })
}

// RSA&AES加密 传入参数:key="12345678",data={"result":"123","message":"welcome here!"}
export function getEncryptResult(key, data) {
  return native({
    className: 'GetEncrypt',
    getEncryptResult: 'getEncryptResult',
    data: [key, data]
  })
}

// 获取登录设备信息
export function getInformation() {
  return native({ className: 'Information', methodName: 'getInformation', data: [] })
}
// 获取地理位置信息 传入参数:[{"228294"},{"225683"}]
export function getPosition(po1, po2) {
  return native({ className: 'GetPosition', methodName: 'getPosition', data: [po1, po2] })
}

// 获取wifi信息
export function getWifiInfo() {
  return native({ className: 'Information', methodName: 'getWifiInfo', data: [] })
}

// 扫描
export function scan() {
  return native({ className: 'BarcodeScanner', methodName: 'scan', data: ['main'] })
}

// 生成二维码
export function createQRCode(url, size) {
  return native({ className: 'BarcodeScanner', methodName: 'createQRCode', data: [url, size] })
}

// 修改原生标题栏标题
export function setTitle(titleName) {
  native({ className: 'CubeTitleBar', methodName: 'setTitle', data: [{ title: titleName }] })
}

// 隐藏标题栏标题
export function hideTheTitleBar() {
  native({
    className: 'CubeTitleBar',
    methodName: 'hideTheTitleBar',
    data: [{ isHideTheTitleBar: '1' }]
  })
}

// 隐藏水印
export function hideWaterView() {
  native({
    className: 'CubeTitleBar',
    methodName: 'hideWaterView',
    data: [{ isHideTheWaterView: '1' }]
  })
}

// 显示水印
export function showWaterView() {
  native({
    className: 'CubeTitleBar',
    methodName: 'showWaterView',
    data: [{ isHideTheWaterView: '0' }]
  })
}

// 播放声音
export function playAttendanceSound() {
  native({ className: 'CubeMedia', methodName: 'playAttendanceSound', data: [{ isSuccess: '0' }] })
}

// 隐藏原生左上角返回键
export function hideWebviewGoBack() {
  native({
    className: 'CubeTitleBar',
    methodName: 'hideWebviewGoBack',
    data: [{ hideWebviewGoBack: '1' }]
  })
}

// 启动NFC
export function nfcEnable() {
  native({ className: 'NFC', methodName: 'NFC_Enable', data: [] })
}

// 写入内容到NFC标签
export function nfcWrite(identity, parameter) {
  native({
    className: 'CubeTitleBar',
    methodName: 'NFC_Write',
    data: [{ identity, parameter }]
  })
}

// 设置屏幕亮度 参数为0-255的整型，数字越大，屏幕越亮。
export function setBrightness(num) {
  native({ className: 'CubeTitleBar', methodName: 'setBrightness', data: [num] })
}

// 获取屏幕亮度 返回如{"value":0.5432512,"value255":145}json字符串。
export function getBrightness() {
  native({ className: 'CubeTitleBar', methodName: 'getBrightness', data: [] })
}

/*
json格式，
title：标题
description:描述
beginTime:开始时间
endTime:结束时间
时间格式为yyyy-MM-dd HH:mm（也可用其他格式，之后app自行转换成需要的格式）
以上四个字段为必填，如果缺少字段或格式错误则返回，不添加该日程。
address:地址
remindTime：提前多少时间（分钟）提醒
这两个字段为选填，address没填默认为空，remindTime没填默认为15分钟。
*/
export function addSchedule(title, description, beginTime, endTime, address, remindTime) {
  native({
    className: 'Schedule',
    methodName: 'addSchedule',
    data: [
      {
        title,
        description,
        beginTime,
        endTime,
        address,
        remindTime
      }
    ]
  })
}

// 设置横屏
export function setLandscape() {
  native({ className: 'CubeTitleBar', methodName: 'setLandscape', data: [{ isLandscape: '1' }] })
}

// 允许长按识别二维码
export function recognitionQRCode() {
  native({
    className: 'CubeTitleBar',
    methodName: 'recognitionQRCode',
    data: [{ isRecognitionQRCode: '1' }]
  })
}

/*
count 表示选择文件的个数，缺省的情况下，默认值为1
justImage表示是否图片视图，缺省的情况下默认值为false
 */
export function getFileArray(count, justImage) {
  return native({ methodName: 'getFileArray', data: [{ 'count ': count, justImage }] })
}
// 从相册选择图片
export function getPhotoFromAlbum() {
  return native({ methodName: 'getPhotoFromAlbum', data: {} })
}
// 显示图片选择器或调用系统拍照弹窗
export function getPhotosOnly() {
  return native({ methodName: 'getPhotosOnly', data: {} })
}

// 显示图片选择器或调用系统拍照弹窗
export function chooseImage(sourceType, compressLimit) {
  return native({
    methodName: 'chooseImage',
    data: {
      sourceType,
      compressLimit
    }
  })
}

// 显示图片选择器或调用系统拍照弹窗
export function getPhoto() {
  return native({ methodName: 'getPhoto', data: {} })
}
// 退出程序
export function quit() {
  native({ className: 'CubeQuit', methodName: 'quit', data: [] })
}

// 跳转模块
export function goToModule(moduleName, param) {
  native({
    className: 'GoToModule',
    methodName: 'goToModule',
    data: [
      {
        identifier: moduleName,
        param,
        enterDirection: 'right'
      }
    ]
  })
}

// 发送消息
export function sendTxtMsg(msg, account) {
  return native({ className: 'GetContacts', methodName: 'sendTxtMsg', data: [msg, account] })
}

// 单聊 对传入的员工号创建发起单人聊天。
export function contact(empID) {
  return native({ className: 'Information', methodName: 'contact', data: [empID] })
}

// 建群 第一个参数表示一组员工号，第二个是聊天主题
export function createGroup(group, subjectName) {
  return native({
    className: 'Information',
    methodName: 'createGroup',
    data: [group, { subject: subjectName }]
  })
}

// 分享图文消息到聊天界面 成功返回字符串：sharetoEhome success!失败返回字符串：sharetoEhome failed!
export function shareToEhome(name, subject, identifier, picture, description, url) {
  native({
    className: 'IMCallBack',
    methodName: 'shareToEhome',
    data: [
      {
        v_name: name,
        v_sub: subject,
        v_identifier: identifier,
        v_pic: picture,
        v_description: description,
        v_url: url
      }
    ]
  })
}
// 上传文件
export function uploadFile(url, filePath, name, header, formData) {
  return native({
    methodName: 'uploadFile',
    data: {
      url,
      filePath,
      name,
      header,
      formData,
      timeout: 10000
    }
  })
}
// 获取文件下载目录
export function getDownloadDirectory(privates) {
  return native({ methodName: 'getDownloadDirectory', data: { private: privates } })
}
// 保存base64图片到本地
export function savePicture(name, base64) {
  return native({ methodName: 'savePicture', data: { name, base64 } })
}
// 会议版专用
// 无纸化会议下载文件及显示
export function downloadAndShowFile(fileUrl, fileUrls, index, title, water, delTime) {
  native({
    className: 'IPadOffice',
    methodName: 'downloadFile',
    data: [[fileUrl, fileUrls], index, title, water, 1, delTime]
  })
}

// 无纸化会议下载文件及隐藏
export function downloadButHideFile(fileUrl, fileUrls, index, title, water, delTime) {
  native({
    className: 'IPadOffice',
    methodName: 'downloadFile',
    data: [[fileUrl, fileUrls], index, title, water, 0, delTime]
  })
}

// 无纸化会议销毁会议材料
export function dumpLocalFile() {
  return native({ className: 'IPadOffice', methodName: 'dumpLocalFile', data: [] })
}

export function getEhomeRequestUrl(url) {
  if (!isEhome) {
    return url
  }
  if (isEhomePro) {
    // TODO生产包走生产路径
    // eslint-disable-next-line no-lonely-if
    if (url.includes('apiEva/ns-service-support-authentication')) {
      // return url.replace('/apiEva', 'http://172.27.214.125/apiEva')
      return url.replace('/apiEva', 'https://ta.csair.com/apiEva')
    } else if (url.includes('apiEva/ns-service-app-system')) {
      // return url.replace('/apiEva', 'http://172.27.214.125/apiEva')
      return url.replace('/apiEva', 'https://ta.csair.com/apiEva')
    } else if (url.includes('apiEva/ns-service-app-evaluation')) {
      // return url.replace('/apiEva', 'http://172.27.214.125/apiEva')
      return url.replace('/apiEva', 'https://ta.csair.com/apiEva')
    } else if (url.includes('wsapi/ns-service-app-general')) {
      // return url.replace('/apiEva', 'http://172.27.214.125/apiEva')
      return url.replace('/wsapi', 'https://ta.csair.com/wsapi')
    } else {
      return url
    }
  } else {
    // 安卓、ios、鸿蒙测试包
    // eslint-disable-next-line no-lonely-if
    if (url.includes('apiEva/ns-service-support-authentication')) {
      // return url.replace('/apiEva', 'http://172.21.128.55:31001')
      return url.replace('/apiEva', 'https://patest.csair.com/apiEva')
    } else if (url.includes('apiEva/ns-service-app-system')) {
      // return url.replace('/apiEva', 'http://172.21.128.55:31004')
      return url.replace('/apiEva', 'https://patest.csair.com/apiEva')
    } else if (url.includes('apiEva/ns-service-app-evaluation')) {
      // return url.replace('/apiEva', 'http://172.21.128.55:31014')
      return url.replace('/apiEva', 'https://patest.csair.com/apiEva')
    } else if (url.includes('wsapi/ns-service-app-general')) {
      // return url.replace('/wsapi', 'http://172.21.128.55:31015')
      return url.replace('/wsapi', 'https://patest.csair.com/wsapi')
    } else {
      return url
    }
  }
}

export const getCopyrightRange = () => {
  const { serverTime } = storeToRefs(useUserStoreWithOut())
  const copyrightRange = ref<string | number>(2024)
  const startYear = 2024
  const curYear = Number(dayjs(serverTime.value).year())
  if (startYear !== curYear) {
    copyrightRange.value = `${2024}-${curYear}`
  }
  return copyrightRange
}
